
const digest = '8cf3410147646e6d7f8b09d5b7275b4bdc0c20b229659af61d778756db9b5d87';
const classes = {"wrapper":"_wrapper_19cnl_1","boldItem":"_boldItem_19cnl_24"};
const css = `._wrapper_19cnl_1 {
  color: #000000;
  font-size: 12px;
  font-family: Rubik, "sans-serif";
  font-weight: 400;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
}
._wrapper_19cnl_1:nth-child(even) {
  background-color: #fbfbfd;
}
._wrapper_19cnl_1:last-of-type {
  border-bottom: none;
}
._wrapper_19cnl_1 td {
  padding: 14px 8px;
}
._wrapper_19cnl_1 td:first-of-type {
  padding-left: 14px;
}
._wrapper_19cnl_1 td:last-of-type {
  padding-right: 14px;
}
._wrapper_19cnl_1 td._boldItem_19cnl_24 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  